<template>
  <shared-messages-callback-number-list
    :callback-numbers="callbackNumbers"
    :show-nav-tab="true"
    :can-send-sms="true"
    @loadCallbackList="loadCallbackNumbers">
  </shared-messages-callback-number-list>
</template>

<script>
import SharedMessagesCallbackNumberList from '@/views/Shared/Messages/CallbackNumbers/List'
import CallbackNumber from '@/models/CallbackNumber'
import Pagination from '@/mixins/paginate'
import Paginate from '@/components/Paginate'

export default {
  name: 'User.Messages.CallbackNumber',
  mixins: [Pagination],
  components: {
    SharedMessagesCallbackNumberList,
    Paginate
  },
  data () {
    return {
      callbackNumbers: {},
      callbackNumberFormData: {
        number: ''
      },
      callbackNumberFormErrors: []
    }
  },
  mounted () {
    this.loadCallbackNumbers(this.initialPage)
    this.$windowOpenerHelper.listenToPopUpMessage('reload_message_callback_table', this.loadCallbackNumbers)
  },
  methods: {
    async loadCallbackNumbers (page) {
      this.$vs.loading({container: '#messageCallbackNumberDataContainer'})

      const response = await CallbackNumber.all({ page })

      this.callbackNumbers = response.data.data.callbackNumbers

      this.$vs.loading.close('#messageCallbackNumberDataContainer > .con-vs-loading')
    }
  }
}
</script>

<style scoped>

</style>
